import "../404.css"

export default function Page404() {
    return (
        <div className="container d-flex justify-content-center align-items-center error-container text-center">
            <div>
                <div className="error-code text-danger">404</div>
                <h2 className="mb-3">Ups! Strony nie znaleziono</h2>
                <p className="mb-4">Strona, której szukasz, nie istnieje lub została przeniesiona.</p>
                <a href="/" className="btn btn-main px-4 py-2">Wróć na stronę główną</a>
            </div>
        </div>
    );
}